export default __webpack_public_path__ + "1398930e459c4472855e3951897dd563.svg";